import type { NodeViewConstructor } from '@milkdown/kit/prose/view';
import { $view } from '@milkdown/kit/utils';
import './groupedCards.css';
import { groupedCardsNode } from './groupedCardsNode';

/**
 * View plugin that renders grouped-cards nodes in the editor.
 *
 * This creates a simple container that matches SlackishMarkdown's DOM structure,
 * allowing the shared CSS grid layout to apply automatically. The child card nodes
 * render inside this container and display side-by-side just like in view mode.
 */
export const groupedCardsView = $view(groupedCardsNode, () => {
  const view: NodeViewConstructor = (_node, _view, _getPos) => {
    // Create simple container matching SlackishMarkdown structure
    const dom = document.createElement('div');
    dom.className = 'grouped-cards';
    dom.dataset.groupedCards = 'true';

    // Add ARIA attributes for accessibility
    dom.setAttribute('role', 'group');
    dom.setAttribute('aria-label', 'Related summary cards');

    // Content DOM is the container itself - children render directly inside
    const contentDOM = dom;

    return {
      dom,
      contentDOM,
      // No update function needed - children handle their own updates
    };
  };

  return view;
});
